import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { GoogleOAuthProvider } from "@react-oauth/google";

import App from "./routes/AppRoutes";
import reportWebVitals from "./reportWebVitals";

import {
  store,
  persistor,
} from "./app/store";

import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider
      clientId={
        process.env.REACT_APP_GOOGLE_CLIENT_ID
      }
    >
      <Provider store={store}>
        <PersistGate
          loading={null}
          persistor={persistor}
        >
          <App />

          <ToastContainer
            position="top-right"
            autoClose={3000}
            limit={1}
          />
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  // </React.StrictMode>
);

reportWebVitals();